import { useEffect, useState } from 'react';

import { Review } from '@/fo/ui/review/catalog/base';
import { UiReviewDetailBase } from '@/fo/ui/review/detail/base';

import { getReview } from '../api/getReview';

export interface FeatureReviewDetailBaseProps {
  reviewId?: string | null;
  onClose?: () => void;
}

export function FeatureReviewDetailBase({
  reviewId,
  onClose
}: FeatureReviewDetailBaseProps) {
  const [review, setReview] = useState<Review | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchReview = async () => {
      setIsLoading(true);

      if (!reviewId) {
        return;
      }

      const review = await getReview(reviewId);

      if (!review) {
        return;
      }

      setReview(review);
      setIsLoading(false);
    };

    fetchReview();
  }, [reviewId]);

  return (
    <UiReviewDetailBase
      open={!!reviewId}
      isLoading={isLoading}
      onOpenChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
      review={review ?? undefined}
    />
  );
}
